/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgrFilterModule, AgrPageToolbarModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';

import { AgrTableModule } from '@next/core-lib/table';
import { LetDirective, PushPipe } from '@ngrx/component';

import { CropAidModule } from '../crop-aid/crop-aid.module';

import { SharedModule } from '../shared/shared.module';

import { SoilTypeModule } from '../soil-type/soil-type.module';

import { FertilizerCommentComponent } from './fertilizer-comment/fertilizer-comment.component';
import { FertilizerFormComponent } from './fertilizer-form/fertilizer-form.component';
import { FertilizerImportDialogComponent } from './fertilizer-import-dialog/fertilizer-import-dialog.component';
import { FertilizerImportTypeDialogComponent } from './fertilizer-import-dialog/fertilizer-import-type-dialog/fertilizer-import-type-dialog.component';
import { AnimalManureTransportsTableComponent } from './fertilizers-overview/animal-manure-transport/animal-manure-transports-table/animal-manure-transports-table.component';
import { FertilizersOverviewComponent } from './fertilizers-overview/fertilizers-overview.component';
import { ManurePeriodComponent } from './fertilizers-overview/manure-period/manure-period.component';
import { ManureTypeComponent } from './fertilizers-overview/manure-type/manure-type.component';
import { FertilizationLegalStandardsQuickViewComponent } from '../fertilization-legal-standards/components/quick-view/fertilization-legal-standards-quick-view.component';
import { ManureSpaceModule } from '../manure-space/manure-space.module';
import { SalesOrderPeriodModule } from '../sales-order-period/sales-order-period.module';
import { FertilizersTableComponent } from './fertilizer-table/fertilizers-table.component';

import { FetchAnimalManureTransportsDialogComponent } from './fertilizers-overview/animal-manure-transport/fetch-animal-manure-transports-dialog/fetch-animal-manure-transports-dialog.component';
import { ManureDetailsComponent } from './fertilizers-overview/manure-details/manure-details.component';
import { SewageSludgeCompostEditTransportComponent } from './fertilizers-overview/sewage-sludge-compost-transport/edit-transport-dialog/sewage-sludge-compost-edit-transport.component';
import { SewageSludgeCompostImportDialogComponent } from './fertilizers-overview/sewage-sludge-compost-transport/import-dialog/sewage-sludge-compost-import-dialog.component';
import { SewageSludgeCompostTableComponent } from './fertilizers-overview/sewage-sludge-compost-transport/table/sewage-sludge-compost-table.component';
import { ImportSetupDialogComponent } from './import-setup-dialog/import-setup-dialog.component';

@NgModule({
  declarations: [
    FertilizersOverviewComponent,
    FertilizerFormComponent,
    FertilizationLegalStandardsQuickViewComponent,
    FertilizerCommentComponent,
    ImportSetupDialogComponent,
    FertilizerImportDialogComponent,
    FetchAnimalManureTransportsDialogComponent,
    AnimalManureTransportsTableComponent,
    FertilizerImportTypeDialogComponent,
    SewageSludgeCompostImportDialogComponent,
    SewageSludgeCompostTableComponent,
    SewageSludgeCompostEditTransportComponent,
    FertilizersTableComponent,
    ManureDetailsComponent,
    ManureTypeComponent,
    ManurePeriodComponent,
  ],
  imports: [
    MatTabsModule,
    CommonModule,
    SharedModule,
    AgrFormModule,
    AgrPageToolbarModule,
    ReactiveFormsModule,
    AgrFilterModule,
    CropAidModule,
    ManureSpaceModule,
    SoilTypeModule,
    SalesOrderPeriodModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    LetDirective,
    PushPipe,
    MatDialogModule,
    MatButtonModule,
    AgrDialogModule,
    AgrTableModule,
    MatTableModule,
  ],
})
export class FertilizersModule {}
